import WarrantyFormHaveCurrentSet from '../Fields/WarrantyFormHaveCurrentSet';
import WarrantyFormHowOftenWear from '../Fields/WarrantyFormHowOftenWear';
import WarrantyFormScanStatus from '../Fields/WarrantyFormScanStatus';

function StepOne() {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-center font-bold text-gray-900 text-xl leading-6">
          Retainer Information
        </h3>
        <p className="mt-1 text-center text-gray-500 text-sm">
          Tell us about your current retainer situation
        </p>
      </div>

      <div className="grid grid-cols-1 gap-6 text-left sm:grid-cols-1">
        {/* Scan Status Dropdown */}
        <WarrantyFormScanStatus />

        {/* Have Current Set Radio Buttons */}
        <WarrantyFormHaveCurrentSet />

        {/* How Often Wear Dropdown */}
        <WarrantyFormHowOftenWear />
      </div>
    </div>
  );
}

export default StepOne;
